import "./Pradžia.css";
import "../../fonts.css";
import ImageFetcher from "../../components/ImageFetcher";

function Pradžia() {
  return (
    <section
      className="pradzia-section"
      style={{
        backgroundImage: `url(https://res.cloudinary.com/dvuaaubys/image/upload/v1764855154/1_snmtxo.jpg)`,
      }}
    >
      <div className="pradžia-container">
        <div className="pradžia-intro-section">
          <ImageFetcher
            image="logo-name_kswvom"
            name="logo-image"
            width={1200}
            height={1200}
          />
        </div>

        <div className="pradžia-quote-box">
          <p className="pradžia-quote-text">
            "Man dar neteko pajausti tokių švelnių, tvirtų ir gilių rankų" taip
            sako Mano Klientai
          </p>
        </div>

        <div className="pradžia-button-container">
          <div className="pradžia-button-wrapper">
            <a href="#contact" className="pradžia-registration-button">
              <i className="fas fa-smile pradžia-icon"></i>
              <span className="pradžia-button-text">Registracija</span>
            </a>
          </div>
        </div>
        <div className="kuponai-container">
          <ImageFetcher image="abonemento_lcyusd" name="kuponai-image" />
          <div className="kuponai-about-container">
            <p className="kuponai-about-text">
              Kai imu štampą į rankas, visada galvoju - kam ši dovana atneš
              šypseną. Kiekvienas kuponas - tarsi mažas pažadas: „sustok,
              atsipalaiduok, pajausk save“.
            </p>
            <p id="text-2" className="kuponai-about-text">
              Kuponą galima įsigyti pasiskambinus telefonu arba atvykus į
              saloną.
              <span className="kuponai-contact-row">
                <a href="tel:(0-636) 68728" className="kuponai-contact-link">
                  (0-636) 68728
                </a>
                <a href="#taisykles" className="kuponai-rules-button">
                  Kuponų taisyklės
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pradžia;
